"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFRAME_STYLE = void 0;
exports.IFRAME_STYLE = 'position: fixed; top: 0; left: 0; z-index: 6001; width: 100%; height: 100%; border: 0;';
//# sourceMappingURL=constants.js.map